import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class WhatsappService {

  constructor(
    private _https: HttpClient
  ) { }

  sendDocumentOnWhatsapp(category: string, id: string, whatsappNumber: string): Observable<any> {
    return this._https.post(`${environment.inventory}/SendWhatsAppDocument/${category}/${id}/${whatsappNumber}`, {});
  }

}
